import axiosAuth from '../../axiosMain';

async function show(company_id) {
  try {
    let response = await axiosAuth.get('/company_certifications/' + company_id);
    return response.data.data;
  } catch (e) {}
}

async function store(data) {
  try {
    let response = await axiosAuth.post('/company_certifications', data);
    return response.data.data;
  } catch (e) {}
}

export default {
  show,
  store,
};
